import api from "./apiBase";

function getWalletBalance() {
  return api.get("/wallets");
}

function updateWalletPix(payload) {
  return api.post("/wallets/pix", payload);
}

function getWalletPix(payload) {
  return api.get("/wallets/pix", payload);
}

/**
 * Busca os detalhes de um pedido a partir do ID de uma transação.
 *
 * @param {number|string} transactionId
 * @returns {Promise} Axios response com os detalhes do pedido
 */
function getTransactionOrder(transactionId) {
  return api.get(`/transactions/${transactionId}/order`);
}

export { getWalletBalance, updateWalletPix, getWalletPix, getTransactionOrder };
